<template>
  <div class="rew19_aro_wrap shop">
    
    <fourplus-introduce-header :activeCount="2"/>
    
    <div class="rew19_contents_inner">
      
      <sns-link
        :snsLinkUrl="snsLinkUrl"
        :snsTitle="'커스텀 프로덕트 세트 4개월 연속 구매하고, 1개 무상 증정 받자!'"
        :snsImgUrl="'https://resource2018.nuskinkorea.co.kr/images/aro/fourplus_intro02.png'"
      />

      <div class="rew19_imgcont_wrap center">
        <div class="rew19_imgarea fourplus02">
          <img src="https://resource2018.nuskinkorea.co.kr/images/aro/ARO_4+1_ageloc_me_1.jpg"
            alt="에이지락 미 4+1정기구매 프로그램이란? 정기구매 웹사이트 또는 모바일 앱을 통해 에이지락 미 커스텀 프로덕트 세트를 매 달 구매시, 10% 할인 혜택은 물론 연속 구매에 따른 사은품을 제공하는 정기구매 전용 프로그램 입니다.">
          <router-link :to="$aroBasePath+'/detail/18010000'" target="_blank">
            <img src="https://resource2018.nuskinkorea.co.kr/images/aro/ARO_4+1_ageloc_me_2.jpg" class="fourplus_mtb">
          </router-link>
          <img src="https://resource2018.nuskinkorea.co.kr/images/aro/ARO_4+1_ageloc_me_3.jpg">
        </div>
      </div><!--//rew19_imgcont_wrap-->
    </div><!--//rew19_contents_inner-->
  </div><!--//rew19_aro_wrap-->
</template>
<script>
import AroBase from '@/components/base/AroBase';
import FourplusIntroduceHeader from './fourplusIntroduceHeader';
import SnsLink from './snsLink';

export default {
  name: 'FourplusIntroduce02',
  extends: AroBase,
  components: { FourplusIntroduceHeader, SnsLink },
  props: {},
  computed : {
    snsLinkUrl : function(){
      let linkUrl = document.location.href;
      let addParams = 'utm_source=kakaotalk&utm_medium=product_detail';
      linkUrl+=(linkUrl.indexOf("?") > 0 ? "&" : "?") + addParams;
      return linkUrl;
    },
  },
  data() {
    return {
    }
  },
  mounted() {
    let _this = this;
  },
  methods :{

  }
}
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/views/info/fourplusIntroduce02.vue